import { call, fork, put, takeEvery } from 'redux-saga/effects';
import * as ga from '../../redux/actions/app';
import {
  getNSCommonModuleFail,
  getNSCommonModuleSuccess,
  NS_GET_COMMON_MODULE_INIT
} from '../../redux/actions/ns/common';
import { getNSCommonModulesService } from '../../services/ns/common';

function* getNSCommonModuleDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getNSCommonModulesService, payload);
    yield put(getNSCommonModuleSuccess(response.data));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getNSCommonModuleFail({ error: '' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchGetNSCommomModuleData() {
  yield takeEvery(NS_GET_COMMON_MODULE_INIT, function* ({ payload }) {
    yield fork(getNSCommonModuleDataWorker, payload);
  });
}
